(function () {
  'use strict';

  var STORAGE_KEY = 'liora:collection-return:v5';
  var HISTORY_KEY = 'lioraCollectionReturnV5';
  var MAX_AGE_MS = 60 * 60 * 1000;
  var restoreRunning = false;
  var restoreQueued = false;
  var restoreToken = 0;
  var lastSavedHandle = '';

  function collectionKey() {
    var url = new URL(window.location.href);
    var ignored = [
      'page',
      'section_id',
      'preview_theme_id',
      'pb',
      '_ab',
      '_fd',
      '_sc'
    ];

    ignored.forEach(function (name) {
      url.searchParams.delete(name);
    });

    var sortedParams = Array.from(url.searchParams.entries()).sort(function (a, b) {
      return (a[0] + '=' + a[1]).localeCompare(b[0] + '=' + b[1]);
    });
    var search = new URLSearchParams(sortedParams).toString();

    return url.pathname + (search ? '?' + search : '');
  }

  function productHandle(href) {
    try {
      var pathname = new URL(href, window.location.href).pathname;
      var match = pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function validState(state) {
    return Boolean(
      state &&
      state.collectionKey === collectionKey() &&
      state.savedAt &&
      Date.now() - state.savedAt <= MAX_AGE_MS
    );
  }

  function readSessionState() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function readHistoryState() {
    try {
      return window.history.state && window.history.state[HISTORY_KEY];
    } catch (error) {
      return null;
    }
  }

  function readState() {
    var sessionState = readSessionState();
    var historyState = readHistoryState();
    var candidates = [sessionState, historyState].filter(validState);

    candidates.sort(function (a, b) {
      return Number(b.savedAt || 0) - Number(a.savedAt || 0);
    });

    return candidates[0] || null;
  }

  function writeState(state) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {}

    try {
      var nextHistoryState = Object.assign({}, window.history.state || {});
      nextHistoryState[HISTORY_KEY] = state;
      window.history.replaceState(nextHistoryState, document.title, window.location.href);
    } catch (error) {}
  }

  function clearState() {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {}

    try {
      var nextHistoryState = Object.assign({}, window.history.state || {});
      delete nextHistoryState[HISTORY_KEY];
      window.history.replaceState(nextHistoryState, document.title, window.location.href);
    } catch (error) {}
  }

  function findProductCard(grid, handle) {
    if (!grid || !handle) return null;
    var cards = grid.querySelectorAll('.grid-item');

    for (var i = 0; i < cards.length; i += 1) {
      if (cards[i].dataset.lioraProduct === handle) return cards[i];

      var links = cards[i].querySelectorAll('a[href*="/products/"]');
      for (var j = 0; j < links.length; j += 1) {
        if (productHandle(links[j].href) === handle) return cards[i];
      }
    }

    return null;
  }

  function pagerElement(root) {
    return root.querySelector('[id^="btn-pagination-"]');
  }

  function closestProductLink(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('#items-grid a[href*="/products/"]');
  }

  function stateForLink(link) {
    var grid = document.getElementById('items-grid');
    var card = link && link.closest('.grid-item');
    var handle = link ? productHandle(link.href) : '';
    if (!grid || !card || !handle) return null;

    var cards = Array.from(grid.querySelectorAll('.grid-item[data-liora-product]'));
    var cardIndex = cards.indexOf(card) + 1;
    var pageSize = Math.max(1, Number(grid.dataset.pageSize || 16));
    var inferredPage = Math.max(1, Math.ceil(cardIndex / pageSize));

    return {
      collectionKey: collectionKey(),
      savedAt: Date.now(),
      productHandle: handle,
      targetPage: Math.max(
        inferredPage,
        Number(card.dataset.lioraPage || 1)
      ),
      loadedPage: Math.max(
        inferredPage,
        Number(card.dataset.lioraPage || 1),
        Number(grid.dataset.currentPage || 1)
      ),
      cardIndex: cardIndex,
      pageSize: pageSize,
      loadedCards: cards.length,
      cardViewportTop: card.getBoundingClientRect().top,
      scrollY: window.scrollY || window.pageYOffset || 0
    };
  }

  function saveLink(link) {
    var state = stateForLink(link);
    if (!state) return;

    lastSavedHandle = state.productHandle;
    writeState(state);

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }

  function saveReturnPoint(event) {
    if (typeof event.button === 'number' && event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    saveLink(closestProductLink(event.target));
  }

  function saveKeyboardReturnPoint(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    saveLink(closestProductLink(document.activeElement));
  }

  function refreshSavedPosition() {
    if (!lastSavedHandle) return;
    var grid = document.getElementById('items-grid');
    var card = findProductCard(grid, lastSavedHandle);
    if (!grid || !card) return;

    var cards = Array.from(grid.querySelectorAll('.grid-item[data-liora-product]'));
    var cardIndex = cards.indexOf(card) + 1;
    var pageSize = Math.max(1, Number(grid.dataset.pageSize || 16));
    var inferredPage = Math.max(1, Math.ceil(cardIndex / pageSize));

    writeState({
      collectionKey: collectionKey(),
      savedAt: Date.now(),
      productHandle: lastSavedHandle,
      targetPage: Math.max(
        inferredPage,
        Number(card.dataset.lioraPage || 1)
      ),
      loadedPage: Math.max(
        inferredPage,
        Number(card.dataset.lioraPage || 1),
        Number(grid.dataset.currentPage || 1)
      ),
      cardIndex: cardIndex,
      pageSize: pageSize,
      loadedCards: cards.length,
      cardViewportTop: card.getBoundingClientRect().top,
      scrollY: window.scrollY || window.pageYOffset || 0
    });
  }

  function makePageUrl(page) {
    var url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.delete('section_id');
    url.searchParams.set('page', String(page));
    return url.toString();
  }

  async function fetchPage(page) {
    var response = await fetch(makePageUrl(page), { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Collection page request failed: ' + response.status);

    var html = new DOMParser().parseFromString(await response.text(), 'text/html');
    return {
      page: page,
      grid: html.getElementById('items-grid'),
      pager: pagerElement(html)
    };
  }

  async function rebuildThroughTargetPage(grid, state) {
    var pageSize = Math.max(
      1,
      Number(state.pageSize || grid.dataset.pageSize || 16)
    );
    var currentProductCards = Array.from(
      grid.querySelectorAll('.grid-item[data-liora-product]')
    );
    var currentCards = currentProductCards.length;
    var markedPage = currentProductCards.reduce(function (highest, item) {
      return Math.max(highest, Number(item.dataset.lioraPage || 1));
    }, 1);
    var startPage = Math.max(
      1,
      markedPage,
      Math.ceil(currentCards / pageSize)
    );
    var targetPage = Math.max(
      startPage,
      Number(state.targetPage || 1),
      Number(state.loadedPage || 1),
      Math.ceil(Number(state.loadedCards || 0) / pageSize),
      Math.ceil(Number(state.cardIndex || 0) / pageSize)
    );
    if (targetPage === startPage) return;

    var requests = [];
    for (var page = startPage + 1; page <= targetPage; page += 1) {
      requests.push(fetchPage(page));
    }

    var pages = await Promise.all(requests);
    pages.sort(function (a, b) { return a.page - b.page; });

    var existingHandles = new Set(
      Array.from(grid.querySelectorAll('.grid-item')).map(function (item) {
        return item.dataset.lioraProduct || '';
      })
    );

    pages.forEach(function (result) {
      if (!result.grid) return;

      Array.from(result.grid.children).forEach(function (item) {
        var handle = item.dataset && item.dataset.lioraProduct;
        if (handle && existingHandles.has(handle)) return;
        if (handle) existingHandles.add(handle);
        grid.appendChild(item);
      });

      var currentPager = pagerElement(document);
      if (currentPager && result.pager) {
        currentPager.innerHTML = result.pager.innerHTML;
      }

      grid.dataset.currentPage = String(result.page);
    });

    document.dispatchEvent(new CustomEvent('eurus:collection:reloaded'));
  }

  function showRestoreNotice() {
    if (document.getElementById('liora-return-notice')) return;

    var notice = document.createElement('div');
    notice.id = 'liora-return-notice';
    notice.setAttribute('role', 'status');
    notice.textContent = 'Returning you to where you left off…';
    notice.style.cssText = 'position:fixed;left:50%;bottom:20px;z-index:9999;transform:translateX(-50%);padding:10px 14px;border-radius:999px;background:#111;color:#fff;font:600 13px/1.2 sans-serif;box-shadow:0 4px 16px rgba(0,0,0,.2);white-space:nowrap';
    document.body.appendChild(notice);
  }

  function hideRestoreNotice() {
    var notice = document.getElementById('liora-return-notice');
    if (notice) notice.remove();
  }

  function stabilizeSavedPosition(card, state, token) {
    return new Promise(function (resolve) {
      var cancelled = false;
      var startedAt = Date.now();
      var timers = [];
      var delays = [0, 60, 160, 360, 750, 1400, 2400, 3800, 5600, 7600];

      var cancelForUser = function () {
        if (Date.now() - startedAt < 800) return;
        cancelled = true;
      };

      var place = function () {
        if (cancelled || token !== restoreToken) return;

        if (card && document.documentElement.contains(card)) {
          var savedTop = Number(state.cardViewportTop);
          if (!Number.isFinite(savedTop)) savedTop = 120;
          var top = card.getBoundingClientRect().top +
            (window.scrollY || window.pageYOffset || 0) -
            savedTop;
          window.scrollTo(0, Math.max(0, top));
        } else {
          window.scrollTo(0, Math.max(0, Number(state.scrollY || 0)));
        }
      };

      window.addEventListener('touchmove', cancelForUser, { passive: true });
      window.addEventListener('wheel', cancelForUser, { passive: true });
      window.addEventListener('pointerdown', cancelForUser, { passive: true });
      window.addEventListener('keydown', cancelForUser);

      delays.forEach(function (delay) {
        timers.push(window.setTimeout(place, delay));
      });

      window.setTimeout(function () {
        timers.forEach(window.clearTimeout);
        window.removeEventListener('touchmove', cancelForUser);
        window.removeEventListener('wheel', cancelForUser);
        window.removeEventListener('pointerdown', cancelForUser);
        window.removeEventListener('keydown', cancelForUser);
        resolve();
      }, 7800);
    });
  }

  async function restoreReturnPoint() {
    if (restoreRunning) return;

    var state = readState();
    if (!state) return;

    restoreRunning = true;
    restoreToken += 1;
    var token = restoreToken;

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    var grid = document.getElementById('items-grid');
    if (!grid) {
      restoreRunning = false;
      return;
    }

    var card = findProductCard(grid, state.productHandle);
    var loadedProductCount = grid.querySelectorAll(
      '.grid-item[data-liora-product]'
    ).length;
    var needsRebuild = !card || loadedProductCount < Number(state.loadedCards || 0);

    try {
      if (needsRebuild) {
        showRestoreNotice();
        await rebuildThroughTargetPage(grid, state);
        card = findProductCard(grid, state.productHandle);
      }

      hideRestoreNotice();
      await stabilizeSavedPosition(card, state, token);

      if (token === restoreToken) {
        clearState();
        lastSavedHandle = '';
        if ('scrollRestoration' in window.history) {
          window.history.scrollRestoration = 'auto';
        }
      }
    } catch (error) {
      hideRestoreNotice();
      console.warn('LIORA collection return restore:', error);
    } finally {
      if (token === restoreToken) restoreRunning = false;
    }
  }

  function queueRestore() {
    if (restoreQueued) return;
    restoreQueued = true;

    window.setTimeout(function () {
      restoreQueued = false;
      restoreReturnPoint();
    }, 0);
  }

  function handlePageHide() {
    refreshSavedPosition();
    restoreToken += 1;
    restoreRunning = false;
    restoreQueued = false;
  }

  document.addEventListener('pointerdown', saveReturnPoint, true);
  document.addEventListener('mousedown', saveReturnPoint, true);
  document.addEventListener('touchstart', saveReturnPoint, { capture: true, passive: true });
  document.addEventListener('click', saveReturnPoint, true);
  document.addEventListener('keydown', saveKeyboardReturnPoint, true);
  window.addEventListener('pagehide', handlePageHide);
  window.addEventListener('pageshow', queueRestore);
  window.addEventListener('popstate', queueRestore);
  window.addEventListener('load', queueRestore);
  document.addEventListener('DOMContentLoaded', queueRestore);

  if (document.readyState !== 'loading') queueRestore();
})();
